import { inject } from '@angular/core';
import { HttpRequest, HttpHandlerFn, HttpEvent, HttpResponse } from '@angular/common/http';
import { Capacitor } from '@capacitor/core';

// Services
import { CommonService } from '../services/common/common.service';
import { ActivationCodeService } from '../services/activation-code/activation-code.service';
import { LoggerService } from '../services/logger/logger.service';

// Package.json
import packageJSon from '../../../../package.json';

// Environment
import { environment } from '../../../environments/environment';
import { of, switchMap } from 'rxjs';

// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
function canLog(url: string): boolean {
  return !url.includes('index.html') && !url.includes('//dev-');
}

// eslint-disable-next-line prefer-arrow/prefer-arrow-functions, @typescript-eslint/explicit-module-boundary-types
export default function intercept(request: HttpRequest<unknown>, next: HttpHandlerFn) {
  const logger = inject(LoggerService);
  const common = inject(CommonService);
  const activationCode = inject(ActivationCodeService);

  const WEBSERVICES_MODE = environment.WEBSERVICES_MODE as 'ONLINE' | 'LOCAL';
  const AUDIO_URL_PREFIX = environment.WEBSERVICES[WEBSERVICES_MODE].AUDIO_URL_PREFIX;

  const { url } = request;

  if (!url.includes(AUDIO_URL_PREFIX)) {
    const platform = common.PLATFORM ?? Capacitor.getPlatform();

    request = request.clone({
      headers: request.headers
        .append('version', packageJSon.version)
        .append('deviceID', common.UUID ?? '')
        .append('lang', common.currentLang ?? '')
        .append('platform', platform)
        .append('activationCode', activationCode.activationCode ?? ''),
    });
  }

  return next(request).pipe(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    switchMap((event: HttpEvent<any>) => {
      if (event instanceof HttpResponse) {
        if (canLog(url)) {
          if (event.status === 200) {
            logger.consoleLog('HttpConfigInterceptor', 'handle', { url, event });
          } else {
            logger.consoleError('HttpConfigInterceptor', 'handle', { url });
          }
        }
      }

      return of(event);
    }),
  );
}
